import { StrategyApi } from '@voladeum/client';
import { VoladeumResponse } from 'client/types';
import { createQuery } from 'utils/queries';

import { Axios } from '../../axios';

import { normalizeStrategies, normalizeStrategy } from './normalizers';
import { CreateStrategy, Strategy, StrategyQuery, UpdateStrategy } from './types';

export class VoladeumStrategies extends Axios {
  async list(query: StrategyQuery): Promise<VoladeumResponse<Strategy[]>> {
    const res = await this.get<VoladeumResponse<StrategyApi[]>>(
      `/v1/strategies/${createQuery(query)}`
    );
    return {
      success: res.success,
      error: res.error,
      data: normalizeStrategies(res.data),
    };
  }

  async fetch(strategy_id?: string): Promise<VoladeumResponse<Strategy>> {
    const res = await this.get<VoladeumResponse<StrategyApi>>(`/v1/strategies/${strategy_id}`);
    return {
      success: res.success,
      error: res.error,
      data: normalizeStrategy(res.data),
    };
  }

  async create(payload: CreateStrategy): Promise<VoladeumResponse<number>> {
    const res = await this.post<VoladeumResponse<number>>('/v1/strategies', payload);
    return {
      success: res.success,
      error: res.error,
      data: res.data,
    };
  }

  async update(strategy_id: number, payload: UpdateStrategy): Promise<VoladeumResponse<number>> {
    const res = await this.put<VoladeumResponse<number>>(`/v1/strategies/${strategy_id}`, payload);
    return {
      success: res.success,
      error: res.error,
      data: res.data,
    };
  }

  async activate(strategy_id: number): Promise<VoladeumResponse<string>> {
    const res = await this.post<VoladeumResponse<string>>(`/v1/strategies/${strategy_id}/activate`);
    return {
      success: res.success,
      error: res.error,
      data: res.data,
    };
  }

  async archive(strategy_id: number): Promise<VoladeumResponse<string>> {
    const res = await this.post<VoladeumResponse<string>>(`/v1/strategies/${strategy_id}/archive`);
    return {
      success: res.success,
      error: res.error,
      data: res.data,
    };
  }
}
